import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Questa riga è FONDAMENTALE
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
// Assicurati che NON ci sia nessuna riga come reportWebVitals(); qui sotto.